// extracted by mini-css-extract-plugin
export var active = "bro-ea";
export var categoryM = "bro-7";
export var categoryMFixed = "bro-pa";
export var categoryMName = "bro-8";
export var categoryProduct = "bro-ha";
export var categoryProductImg = "bro-ia";
export var categoryProductName = "bro-ja";
export var categoryProductOrigin = "bro-ka";
export var categoryProductPrice = "bro-la";
export var categoryProductPriceCn = "bro-ma";
export var categoryProductPriceEn = "bro-na";
export var categoryProductTag = "bro-oa";
export var categorySection = "bro-ga";
export var filterChoose = "bro-ba";
export var filterContent = "bro-9";
export var filterItem = "bro-ca";
export var filterItemText = "bro-da";
export var filterList = "bro-fa";
export var minWidthLimit = "bro-6";
export var searchMoreKeywords = "bro-qa";
export var searchMoreKeywordsList = "bro-sa";
export var searchMoreKeywordsTitle = "bro-ra";
export var searchRelatedArticles = "bro-ta";
export var searchRelatedArticlesTitle = "bro-ua";
export var toLeft = "bro-aa";